import type { ThemeChoices } from "$/lib/types/General.types";
import { DEFAULT_GRAPH_TABS } from "$/lib/utils/constants/marketMonitoring/graphs.constants";
import Flexbox from "../../common/Flexbox";
import { DateRangePickerInput } from "../DateRangePickerInput";

type Props = {
  dateRange: [Date, Date];
  setDateRange: (dateRange: [Date, Date]) => void;
  selectedGraphTabId?: string;
  setSelectedGraphTabId?: (id: string) => void;
  theme?: ThemeChoices;
};

const GraphDateRangeSelector = ({
  dateRange,
  setDateRange,
  selectedGraphTabId,
  setSelectedGraphTabId,
  theme = "blue",
}: Props) => (
  <Flexbox className="gap-1">
    <p className="whitespace-nowrap text-base font-semibold text-secondary">
      Plage de dates
    </p>
    <DateRangePickerInput
      startDate={dateRange[0]}
      endDate={dateRange[1]}
      onChange={(date) => {
        if (!date[0] || !date[1]) return;
        setDateRange([date[0], date[1]]);
        if (!setSelectedGraphTabId) return;
        setSelectedGraphTabId("CUSTOM");
      }}
      popperPlacement="bottom-start"
      monthsShown={2}
      className="px-0"
      tabs={
        selectedGraphTabId && setSelectedGraphTabId
          ? {
              options: DEFAULT_GRAPH_TABS,
              selectedTabId: selectedGraphTabId,
              setSelectedTabId: setSelectedGraphTabId,
            }
          : undefined
      }
      theme={theme}
    />
  </Flexbox>
);

export default GraphDateRangeSelector;
